module.exports = __webpack_public_path__ + "img/img73.19b21e5e.svg";